import React, { useState } from 'react';
import { generateRebuttal } from '../services/perplexityService';

const RebuttalGenerator = ({ selectedArgument }) => {
    const [rebuttal, setRebuttal] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleGenerateRebuttal = async () => {
        if (!selectedArgument) return;

        setLoading(true);
        setError('');

        try {
            const response = await generateRebuttal(selectedArgument);
            setRebuttal(response);
        } catch (err) {
            setError('Failed to generate rebuttal. Please try again.');
            console.error('Error generating rebuttal:', err);
        } finally {
            setLoading(false);
        }
    };

    
    const formatText = (text) => {
        if (!text) return null;
        return text.split('\n').map((paragraph, i) => 
            paragraph.trim() ? <p key={i}>{paragraph}</p> : null
        );
    };

    return (
        <div className="rebuttal-generator">
            <h3>Rebuttal Generator</h3>
            <div className="rebuttal-selected-argument">
                <h4>Selected Argument:</h4>
                <div className="selected-argument-content">
                    <p><strong>{selectedArgument.title}</strong></p>
                    <div className="argument-snippet">{selectedArgument.text.substring(0, 150)}...</div>
                </div>
            </div>
            
            <button onClick={handleGenerateRebuttal} disabled={loading} className="rebuttal-button">
                {loading ? 'Generating...' : 'Generate Rebuttal'}
            </button>
            
            {error && <p className="error">{error}</p>}
            
            {rebuttal && (
                <div className="rebuttal-output">
                    <h4>{rebuttal.title || 'Generated Rebuttal'}</h4>
                    <div className="rebuttal-text">
                        {formatText(rebuttal.text)}
                    </div>
                    
                    {rebuttal.counterpoints && rebuttal.counterpoints.length > 0 && (
                        <div className="rebuttal-counterpoints">
                            <h5>Key Counterpoints:</h5>
                            <ul>
                                {rebuttal.counterpoints.map((point, i) => (
                                    <li key={i}>{point}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    
                    {rebuttal.sources && rebuttal.sources.length > 0 && (
                        <div className="rebuttal-sources">
                            <h5>Sources:</h5>
                            <ul>
                                {rebuttal.sources.map((source, i) => (
                                    <li key={i}>
                                        <a href={source.link} target="_blank" rel="noopener noreferrer">
                                            {source.title || source.link}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default RebuttalGenerator;